export const MOBILE_PLATFORMS = ["Android", "iOS", "Windows Phone"];
